import { render, staticRenderFns } from "./shopBlackList.vue?vue&type=template&id=656210ec&scoped=true"
import script from "./shopBlackList.vue?vue&type=script&lang=js"
export * from "./shopBlackList.vue?vue&type=script&lang=js"
import style0 from "./shopBlackList.vue?vue&type=style&index=0&id=656210ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656210ec",
  null
  
)

export default component.exports